// Utility for smooth marker animation/interpolation
// Usage: interpolatePosition(start, end, t)
export function interpolatePosition(start: [number, number], end: [number, number], t: number): [number, number] {
  // Linear interpolation between two lat/lng points
  return [
    start[0] + (end[0] - start[0]) * t,
    start[1] + (end[1] - start[1]) * t
  ];
}

// Returns an array of points (lat, lng) interpolated between start and end
// count: number of intermediate points (not including start/end)
export function interpolatePath(start: [number, number], end: [number, number], count: number): [number, number][] {
  const points: [number, number][] = [];
  for (let i = 1; i <= count; i++) {
    const t = i / (count + 1);
    points.push(interpolatePosition(start, end, t));
  }
  return points;
}
